import { IObjectDef } from "./../types/object";
import React from "react";

const ObjectContext = React.createContext<Record<string, IObjectDef>>({});
export const Consumer = ObjectContext.Consumer;

export default ObjectContext;
